<template>
  <div class="loginBox">
    <div class="pics">
      <template v-if="!isPersonal">
        <img :src="pics[0]" alt="" />
        <div class="tips" v-if="pics.length > 1">
          （被授权查验的用户扫描二维码即可查询用户的信息）
        </div>
        <img :src="pics[1]" alt="" />
      </template>
      <template v-else>
        <div class="swiper">
          <div class="swiper_text" v-if="swiperIndex === 0">
            国家权威平台认证 区块链安全加密
          </div>
          <div class="swiper_text" v-if="swiperIndex === 1">
            数据全程溯源 来源可查去向可追
          </div>
          <div class="swiper_text" v-if="swiperIndex === 2">
            授权扫码查验 牢筑隐私保护高墙
          </div>
          <div class="swiper_text" v-if="swiperIndex === 3">
            多场景增信展示 信用背书有据可查
          </div>
          <div class="swiper_dots">
            <div
              @click="handleSwiperIndex(index)"
              :class="`swiper_dot ${swiperIndex === index ? 'active' : ''}`"
              v-for="(item, index) in pics"
              :key="index"
            ></div>
          </div>
          <div class="swiper_list">
            <div class="swiper_item" v-if="swiperIndex === 0">
              <img :src="pics[0]" alt="" />
            </div>
            <div class="swiper_item" v-if="swiperIndex === 1">
              <img :src="pics[1]" alt="" />
            </div>
            <div class="swiper_item" v-if="swiperIndex === 2">
              <img :src="pics[2]" alt="" />
            </div>
            <div class="swiper_item" v-if="swiperIndex === 3">
              <img :src="pics[3]" alt="" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="form">
      <div class="title">{{ title }}</div>
      <div class="description">
        {{ description }}
      </div>
      <!-- 个人服务登录 -->
      <div v-if="$route.name === 'PersonalServices'" class="personal-login">
        <div class="nav">
          <div
            :class="{ active: loginType === 'qrCode' }"
            @click="loginTypeChange('qrCode')"
          >
            扫码登录
          </div>
          <div
            :class="{ active: loginType === 'form' }"
            @click="loginTypeChange('form')"
          >
            账号登录
          </div>
        </div>

        <div v-if="loginType === 'qrCode' && !socketData" class="code-box">
          <div>请打开溯源优才小程序/APP扫描下方二维码</div>
          <QRcode
            v-if="codeId"
            :QRlink="codeId"
            :qrwidth="185"
            :qrheight="185"
            class="qr-code"
          />
          <div class="refresh">
            如二维码已过期请点击
            <el-link
              type="primary"
              :underline="false"
              style="margin-left:10px"
              @click="initSocket"
              >刷新</el-link
            >
          </div>
        </div>

        <div
          v-if="loginType === 'qrCode' && socketData && socketData.type === 0"
          class="success-box"
        >
          <img
            src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/success.png"
            alt=""
          />
          <div>扫码成功！</div>
          <div class="hint">请在手机上确认登录</div>
        </div>

        <div v-if="loginType === 'form'" class="login-form-box">
          <el-form :model="form" class="form">
            <!-- style="width:378px;height:58px" -->
            <el-form-item>
              <el-input
                autocomplete="off"
                v-model="form.username"
                :placeholder="usernamePlaceholder"
                class="input"
              ></el-input>
            </el-form-item>
            <!-- style="width:378px" -->
            <el-form-item>
              <el-input
                autocomplete="off"
                v-model="form.password"
                :type="passType"
                :placeholder="passwordPlaceholder"
                class="input"
              ></el-input>
              <span
                v-if="showSms"
                class="btnSms"
                @click="timer === 60 ? handleGetSms() : ''"
                >{{ btnSmsText }}</span
              >
            </el-form-item>

            <el-form-item v-if="$route.name === 'PersonalServices'">
              <div class="tip">
                <i class="icon_warning"></i
                >若该手机号码未注册，登陆后将自动为您注册账号
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="handleLogin"
                style="width: 100%; height:50px"
                >登录</el-button
              >
            </el-form-item>
            <el-form-item v-if="$route.name === 'PersonalServices'">
              <div class="isAgree">
                <el-checkbox style="font-size:12px" v-model="isAgree"
                  >已阅读并同意</el-checkbox
                >
                <router-link class="link" to="agreement" target="_blank"
                  >《用户协议》</router-link
                >
                和
                <router-link class="link" to="private" target="_blank"
                  >《隐私政策》</router-link
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 其它登录 -->
      <el-form v-else :model="form">
        <el-form-item style="width:378px;height:58px">
          <el-input
            autocomplete="off"
            v-model="form.username"
            :placeholder="usernamePlaceholder"
          ></el-input>
        </el-form-item>
        <el-form-item style="width:378px">
          <el-input
            autocomplete="off"
            v-model="form.password"
            :type="passType"
            :placeholder="passwordPlaceholder"
          ></el-input>
          <span
            v-if="showSms"
            class="btnSms"
            @click="timer === 60 ? handleGetSms() : ''"
            >{{ btnSmsText }}</span
          >
        </el-form-item>
        <el-form-item v-if="$route.name === 'PersonalServices'">
          <div class="isAgree">
            <el-checkbox style="font-size:12px" v-model="isAgree"
              >已阅读并同意</el-checkbox
            >
            <router-link class="link" to="agreement" target="_blank"
              >《用户协议》</router-link
            >
            和
            <router-link class="link" to="private" target="_blank"
              >《隐私政策》</router-link
            >
          </div>
        </el-form-item>
        <el-form-item v-if="$route.name === 'PersonalServices'">
          <div class="tip">
            <i class="icon_warning"></i
            >若该手机号码未注册，登陆后将自动为您注册账号
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" style="width:378px"
            >登录</el-button
          >
        </el-form-item>
      </el-form>

      <div class="statement">
        <div>平台严正声明：</div>
        <div>
          1、平台存储的所有个人数据，均经过本人授权采集，严格遵守国家相关法律法规进行管理。
        </div>
        <div>
          2、未经本人授权的情况下，本平台数据不会对任何单位及个人提供任何形式的搜索、查看、分析。
        </div>
      </div>
    </div>
    <div class="goMini" v-if="$route.name === 'PersonalServices'">
      <!-- <div class="miniQrBox"><div class="miniQr"></div></div>
      <div class="textBox">
        <div>扫一扫，打开个人服务</div>
        <div>微信小程序</div>
      </div> -->
      <!-- width="200" -->
      <el-popover placement="bottom-end" trigger="hover">
        <div slot="reference" class="btn-item">
          <img src="../assets/phone.png" alt="" />
          个人服务APP
        </div>
        <div class="qr-box">
          <QRcode
            QRlink="https://chrivc.com/mobile/#/appdownload"
            :qrwidth="122"
            :qrheight="122"
            class="qr"
          />
          扫一扫，下载<br />个人服务APP（安卓）
        </div>
      </el-popover>
      <el-popover placement="bottom-end" trigger="hover">
        <div slot="reference" class="btn-item">
          <img src="../assets/wechart.png" alt="" />
          个人服务小程序
        </div>
        <div class="qr-box">
          <img
            src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/miniQr.png"
            class="qr"
          />
          扫一扫，打开个人服务<br />微信小程序
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
const socketApi = process.env.VUE_APP_SOCKET_API;
import JSEncrypt from "jsencrypt";
import { v4 as uuidv4 } from "uuid";
import { getSms } from "@/api/user";
import QRcode from "./QRcode.vue";
import checkPermission from "@/utils/permission";
import { loginFormOptions } from "@/utils/define";
export default {
  components: { QRcode },
  // props: ["title", "pics", "description","isPersonal"],
  props: {
    title: {
      type: String
    },
    pics: {
      type: Array
    },
    description: {
      type: String
    },
    isPersonal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        staffType: "",
        secondaryType: ""
      },
      usernamePlaceholder: "",
      passwordPlaceholder: "",
      passType: "",
      btnSmsText: "获取验证码",
      showSms: false,
      timer: 60,
      publicKey:
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDP1WOya5Ut9LdR6sRdaDzFjXNH3UIv5m8sJAXqow+BOOGbSsDWTZgTdbGv7JzRo5YZVMC0wg+UwNH7zD3UVKJqtaHPUavh4+j/UIzD615X0gFDbVUCBusxCVNj68L4iXP/dqRZfqD6s72f4YPwhHsHvHLdQkGYBL9ls3/Ds9rXEQIDAQAB",
      isAgree: false,
      swiperIndex: 0,
      swiperInterval: undefined,

      socket: null,
      socketData: null,
      codeId: "",
      loginType: "qrCode", // qrCode form

      pageInfo: null
    };
  },
  created() {
    const { name, meta } = this.$route;
    const { title } = meta;
    localStorage.setItem("headerTitle", title);

    switch (name) {
      case "PersonalServices":
        this.form.staffType = "CONSUMER";
        this.form.secondaryType = undefined;
        this.usernamePlaceholder = "请输入手机号";
        this.passwordPlaceholder = "请输入验证码";
        this.passType = "";
        this.showSms = true;
        this.initSocket();
        break;
      case "EducationalServices":
        this.form.staffType = "BUSINESS";
        this.form.secondaryType = "ACADEMIC_EDUCATION";
        this.usernamePlaceholder = "请输入账号";
        this.passwordPlaceholder = "请输入密码";
        this.passType = "password";
        this.showSms = false;
        break;
      case "EmployerServices":
        this.form.staffType = "BUSINESS";
        this.form.secondaryType = "EMPLOYER";
        this.usernamePlaceholder = "请输入账号";
        this.passwordPlaceholder = "请输入密码";
        this.passType = "password";
        this.showSms = false;
        break;
      default:
        this.usernamePlaceholder = "请输入账号";
        this.passwordPlaceholder = "请输入密码";
        this.passType = "password";
        this.showSms = false;
    }

    const token = sessionStorage.getItem("token");
    const info = loginFormOptions.find(item => item.pathName === name);
    this.pageInfo = info;

    if (token && info && checkPermission(info.roles)) {
      this.$router.replace(info.homePath);
    }
    this.swiperInit();
  },
  beforeDestroy() {
    this.closeSocket();
  },
  methods: {
    initSocket() {
      this.closeSocket();
      const id = uuidv4();
      // console.log(id)
      this.codeId = `https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=3&query=${encodeURIComponent(
        "id=" + id
      )}`;
      //  id
      // console.log(this.codeId)
      const socket = new WebSocket(
        `${socketApi}/consumer/webSocket/getLink/${id}`
      );
      socket.onopen = e => {
        // console.log(e)
      };
      socket.onmessage = e => {
        let { data } = e;
        if (data) {
          data = JSON.parse(data);
          // console.log(data)
          const { type, message } = data;
          if (type) {
            // console.log(message)
            this.$store.commit("user/SET_TOKEN", message);
            this.loginNext(message);
          }
          this.socketData = data;
        }
      };
      this.socket = socket;
    },
    closeSocket() {
      if (this.socket) {
        this.socket.close();
        this.socketData = null;
      }
    },
    loginTypeChange(type) {
      const { loginType } = this;
      if (loginType !== type) {
        this.loginType = type;
        if (type === "qrCode") this.initSocket();
      }
    },
    swiperInit() {
      this.swiperInterval = setInterval(() => {
        this.swiperIndex++;
        if (this.swiperIndex === 4) {
          this.swiperIndex = 0;
        }
      }, 3000);
    },
    getEncrypt(data) {
      let encrypt = new JSEncrypt();
      // 设置公钥
      encrypt.setPublicKey(this.publicKey);
      return encrypt.encrypt(data);
    },
    handleGetSms() {
      // console.log("getSms");
      const { name } = this.$route;
      if (name === "PersonalServices") {
        if (!this.form.username.length) {
          this.$message.error("手机号不能为空");
          return false;
        }
        if (this.form.username.length !== 11) {
          this.$message.error("手机号格式错误");
          return false;
        }
      }
      if (this.form.username != "") {
        const encrypted = this.getEncrypt(this.form.username);
        this.btnSmsText = `${this.timer}s`;
        getSms({ phoneNumber: encrypted }).then(res => {
          // console.log(res);
          if (res.data.c === 200) {
            this.$message.success("验证码已发送");
            let interval = setInterval(() => {
              this.timer--;
              this.btnSmsText = `${this.timer}s`;
              if (this.timer === 0) {
                this.timer = 60;
                clearInterval(interval);
                this.btnSmsText = `获取验证码`;
              }
            }, 1000);
          }
        });
      } else {
        this.$message.error({
          message: "手机号不能为空"
        });
      }
    },
    async handleLogin() {
      this.$store.dispatch("user/logout");
      const { name } = this.$route;
      // let login = cLogin;
      // if (name !== "PersonalServices") {
      //   login = bLogin;
      // }

      if (name === "PersonalServices") {
        if (this.form.username.length !== 11) {
          this.$message.error("手机号格式错误");
          return false;
        }
        if (!this.form.password) {
          this.$message.error("验证码不能为空");
          return false;
        }
        if (!this.isAgree) {
          this.$message.error("请先阅读并勾选用户协议和隐私政策");
          return false;
        }
      }
      await this.$store.dispatch("user/login", this.form);
      this.loginNext();
      // this.$store.commit('user/SET_TOKEN', token)
      // login(this.form).then(res => {
      //   if (res.data.c === 200) {
      //     this.loginNext(res.data.d)
      //   }
      // });
    },
    loginNext(token) {
      console.log('pageInfo',this.pageInfo);
      if (this.pageInfo)
        sessionStorage.setItem("loginFormInfo", JSON.stringify(this.pageInfo));
      sessionStorage.setItem("platform", this.pageInfo.platform);
      const { path } = this.$route;
      this.$router.push(path + "Home");
      // this.$router.push(`${path}`);
    },
    handleSwiperIndex(index) {
      this.swiperIndex = index;
      clearInterval(this.swiperInterval);
      this.swiperInit();
    }
  }
};
</script>

<style scoped lang="scss">
// .loginLayout {
//   padding: 68px 0;
//   background-size: cover !important;
.loginBox {
  box-shadow: 0 0 10px 0 rgba(58, 97, 177, 0.18);
  padding: 97px 89px 97px 98px;
  display: flex;
  width: 1200px;
  margin: 68px auto 0 auto;
  background: #fff;
  box-sizing: border-box;
  justify-content: space-between;
  position: relative;
  //   margin: 68px auto;
  .pics {
    display: flex;
    flex-direction: column;
    // width: 600px;
    img {
      margin-bottom: 38px;
      &:first-child {
        width: 473px;
      }
      &:last-child {
        margin-bottom: 0;
        width: 381px;
      }
    }
    div {
      color: #6e6e6e;
      font-size: 14px;
      // padding-left: 6px;
      margin-bottom: 14px;
    }
  }
  .form {
    // padding: 0 0 0 124px;
    width: 389px;
    color: #6e6e6e;
    .title {
      color: #393939;
      font-size: 20px;
      margin-bottom: 30px;
      font-weight: 600;
    }
    .personal-login {
      border: 1px solid #e4e4e4;
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 430px;
      box-sizing: border-box;
      padding: 27px 0;
      .nav {
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #393939;
        div {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          &:first-child {
            margin-right: 47px;
          }
          &.active {
            font-weight: 500;
            color: #3a61b1;
            &::after {
              content: " ";
              width: 32px;
              height: 3px;
              background: #3a61b1;
              // border: 1px solid #3A61B1;
              margin-top: 10px;
            }
          }
        }
      }
      .code-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #8d8d8d;
        margin-top: 28px;
        .qr-code {
          padding: 10px;
          border: 1px solid #eeeeee;
          margin-top: 20px;
          margin-bottom: 26px;
        }
        .refresh {
          font-size: 14px;
          display: flex;
        }
      }
      .success-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 73px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #8d8d8d;
        img {
          width: 65px;
          margin-bottom: 15px;
        }
        .hint {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #393939;
          margin-top: 14px;
        }
      }
      .login-form-box {
        margin-top: 29px;
        box-sizing: border-box;
        padding: 0 25px;
        .form {
          width: 327px;
          .input {
            height: 50px;
          }
          .tip {
            white-space: nowrap;
          }
        }
      }
    }
    .btnSms {
      position: absolute;
      right: 39px;
      top: 9px;
      cursor: pointer;
      color: #5673b0;
    }
    >>> .el-input__inner {
      height: 58px;
      border-radius: 29px;
      background: #f2f3f4;
      border: 0;
      padding-left: 39px;
    }
    .description {
      color: #6e6e6e;
      margin-bottom: 31px;
      line-height: 30px;
      font-size: 14px;
    }
    .el-button--primary {
      background: #3a61b1;
      border-radius: 29px;
      border: 0;
      width: 240px;
      height: 58px;
      font-size: 20px;
      color: #fff;
    }

    .statement {
      font-size: 14px;
      line-height: 30px;
      margin-top: 30px;
    }
  }
  .isAgree {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 30px;
    .link {
      color: #5673b0;
      text-decoration: initial;
      font-family: "PingFang MEDIUM";
    }
  }
  .tip {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ff8d65;
    line-height: 0px;
    .icon_warning {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
        no-repeat;
      background-size: cover;
      display: inline-block;
      margin-right: 8px;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  .goMini {
    position: absolute;
    right: 30px;
    top: 20px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 16px;
    text-align: right;

    display: flex;
    .btn-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 94px;
      height: 43px;
      padding: 7px 3px 7px 7px;
      box-sizing: border-box;
      border: 1px solid #ededed;
      border-radius: 6px;
      margin-left: 16px;
      cursor: pointer;
    }
  }
}
.qr-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #6e6e6e;
  line-height: 18px;
  text-align: center;
  .qr {
    margin-bottom: 10px;
    width: 122px;
    height: 122px;
  }
}

>>> .el-checkbox__inner {
  border-radius: 4px;
}
.swiper {
  text-align: center;
  .swiper_text {
    font-size: 20px !important;
    font-family: PingFang SC;
    font-weight: bold !important;
    color: #6b6b6b !important;
    line-height: 36px;
  }
  .swiper_dots {
    display: flex;
    justify-content: center;
    .swiper_dot {
      width: 8px;
      height: 8px;
      background: #2961de;
      opacity: 0.26;
      border-radius: 4px;
      box-sizing: border-box;
      margin-left: 10px;
      cursor: pointer;
    }
    .active {
      width: 15px;
      opacity: 1;
    }
  }

  .swiper_list {
    .swiper_item {
      img {
        width: 447px;
      }
    }
  }
}
// }
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue